import BattleWonLock1x from "../assets/achievements/battles_won/battles_won_1x.webp";
import BattleWonLock2x from "../assets/achievements/battles_won/battles_won_2x.webp";
import BattleWonLock3x from "../assets/achievements/battles_won/battles_won_3x.webp";
import BattleWon1x from "../assets/achievements/battles_won_level_1/name_battles_won_level_1_1x.webp";
import BattleWon2x from "../assets/achievements/battles_won_level_1/name_battles_won_level_1_2x.webp";
import BattleWon3x from "../assets/achievements/battles_won_level_1/name_battles_won_level_1_3x.webp";
import BattleWon21x from "../assets/achievements/battles_won_level_2/name_battles_won_level_2_1x.webp";
import BattleWon22x from "../assets/achievements/battles_won_level_2/name_battles_won_level_2_2x.webp";
import BattleWon23x from "../assets/achievements/battles_won_level_2/name_battles_won_level_2_3x.webp";
import BattleWon31x from "../assets/achievements/battles_won_level_3/name_battles_won_level_3_1x.webp";
import BattleWon32x from "../assets/achievements/battles_won_level_3/name_battles_won_level_3_2x.webp";
import BattleWon33x from "../assets/achievements/battles_won_level_3/name_battles_won_level_3_3x.webp";

import BattleStreakLock1x from "../assets/achievements/battle_streak/battle_streak_1x.webp";
import BattleStreakLock2x from "../assets/achievements/battle_streak/battle_streak_2x.webp";
import BattleStreakLock3x from "../assets/achievements/battle_streak/battle_streak_3x.webp";
import BattleStreak1x from "../assets/achievements/battle_streak_level_1/name_battle_streak_level_1_1x.webp";
import BattleStreak2x from "../assets/achievements/battle_streak_level_1/name_battle_streak_level_1_2x.webp";
import BattleStreak3x from "../assets/achievements/battle_streak_level_1/name_battle_streak_level_1_3x.webp";
import BattleStreak21x from "../assets/achievements/battle_streak_level_2/name_battle_streak_level_2_1x.webp";
import BattleStreak22x from "../assets/achievements/battle_streak_level_2/name_battle_streak_level_2_2x.webp";
import BattleStreak23x from "../assets/achievements/battle_streak_level_2/name_battle_streak_level_2_3x.webp";
import BattleStreak31x from "../assets/achievements/battle_streak_level_3/name_battle_streak_level_3_1x.webp";
import BattleStreak32x from "../assets/achievements/battle_streak_level_3/name_battle_streak_level_3_2x.webp";
import BattleStreak33x from "../assets/achievements/battle_streak_level_3/name_battle_streak_level_3_3x.webp";

import ChallengerLock1x from "../assets/achievements/challenger/challenger_1x.webp";
import ChallengerLock2x from "../assets/achievements/challenger/challenger_2x.webp";
import ChallengerLock3x from "../assets/achievements/challenger/challenger_3x.webp";
import Challenger1x from "../assets/achievements/challlenger_level_1/name_challlenger_level_1_1x.webp";
import Challenger2x from "../assets/achievements/challlenger_level_1/name_challlenger_level_1_2x.webp";
import Challenger3x from "../assets/achievements/challlenger_level_1/name_challlenger_level_1_3x.webp";
import Challenger21x from "../assets/achievements/challlenger_level_2/name_challlenger_level_2_1x.webp";
import Challenger22x from "../assets/achievements/challlenger_level_2/name_challlenger_level_2_2x.webp";
import Challenger23x from "../assets/achievements/challlenger_level_2/name_challlenger_level_2_3x.webp";
import Challenger31x from "../assets/achievements/challlenger_level_3/name_challlenger_level_3_1x.webp";
import Challenger32x from "../assets/achievements/challlenger_level_3/name_challlenger_level_3_2x.webp";
import Challenger33x from "../assets/achievements/challlenger_level_3/name_challlenger_level_3_3x.webp";

import CompletionistLock1x from "../assets/achievements/completionist/completionist_1x.webp";
import CompletionistLock2x from "../assets/achievements/completionist/completionist_2x.webp";
import CompletionistLock3x from "../assets/achievements/completionist/completionist_3x.webp";
import Completionist1x from "../assets/achievements/completionist_level_1/name_completionist_level_1_1x.webp";
import Completionist2x from "../assets/achievements/completionist_level_1/name_completionist_level_1_2x.webp";
import Completionist3x from "../assets/achievements/completionist_level_1/name_completionist_level_1_3x.webp";
import Completionist21x from "../assets/achievements/completionist_level_2/name_completionist_level_2_1x.webp";
import Completionist22x from "../assets/achievements/completionist_level_2/name_completionist_level_2_2x.webp";
import Completionist23x from "../assets/achievements/completionist_level_2/name_completionist_level_2_3x.webp";
import Completionist31x from "../assets/achievements/completionist_level_3/name_completionist_level_3_1x.webp";
import Completionist32x from "../assets/achievements/completionist_level_3/name_completionist_level_3_2x.webp";
import Completionist33x from "../assets/achievements/completionist_level_3/name_completionist_level_3_3x.webp";

import FriendsInvitedLock1x from "../assets/achievements/friend_invited/friend_invited_1x.webp";
import FriendsInvitedLock2x from "../assets/achievements/friend_invited/friend_invited_2x.webp";
import FriendsInvitedLock3x from "../assets/achievements/friend_invited/friend_invited_3x.webp";
import FriendsInvited1x from "../assets/achievements/friends_invited_level_1/name_friends_invited_level_1_1x.webp";
import FriendsInvited2x from "../assets/achievements/friends_invited_level_1/name_friends_invited_level_1_2x.webp";
import FriendsInvited3x from "../assets/achievements/friends_invited_level_1/name_friends_invited_level_1_3x.webp";
import FriendsInvited21x from "../assets/achievements/friends_invited_level_2/name_friends_invited_level_2_1x.webp";
import FriendsInvited22x from "../assets/achievements/friends_invited_level_2/name_friends_invited_level_2_2x.webp";
import FriendsInvited23x from "../assets/achievements/friends_invited_level_2/name_friends_invited_level_2_3x.webp";
import FriendsInvited31x from "../assets/achievements/friends_invited_level_3/name_friends_invited_level_3_1x.webp";
import FriendsInvited32x from "../assets/achievements/friends_invited_level_3/name_friends_invited_level_3_2x.webp";
import FriendsInvited33x from "../assets/achievements/friends_invited_level_3/name_friends_invited_level_3_3x.webp";

import TimePlayedLock1x from "../assets/achievements/time_played/time_played_1x.webp";
import TimePlayedLock2x from "../assets/achievements/time_played/time_played_2x.webp";
import TimePlayedLock3x from "../assets/achievements/time_played/time_played_3x.webp";
import TimePlayed1x from "../assets/achievements/time_played_level_1/name_time_played_level_1_1x.webp";
import TimePlayed2x from "../assets/achievements/time_played_level_1/name_time_played_level_1_2x.webp";
import TimePlayed3x from "../assets/achievements/time_played_level_1/name_time_played_level_1_3x.webp";
import TimePlayed21x from "../assets/achievements/time_played_level_2/name_time_played_level_2_1x.webp";
import TimePlayed22x from "../assets/achievements/time_played_level_2/name_time_played_level_2_2x.webp";
import TimePlayed23x from "../assets/achievements/time_played_level_2/name_time_played_level_2_3x.webp";
import TimePlayed31x from "../assets/achievements/time_played_level_3/name_time_played_level_3_1x.webp";
import TimePlayed32x from "../assets/achievements/time_played_level_3/name_time_played_level_3_2x.webp";
import TimePlayed33x from "../assets/achievements/time_played_level_3/name_time_played_level_3_3x.webp";

import TournamentsParticipationLock1x from "../assets/achievements/tournament_participation/tournament_participation_1x.webp";
import TournamentsParticipationLock2x from "../assets/achievements/tournament_participation/tournament_participation_2x.webp";
import TournamentsParticipationLock3x from "../assets/achievements/tournament_participation/tournament_participation_3x.webp";
import TournamentsParticipation1x from "../assets/achievements/tournaments_participation_level_1/name_tournaments_participation_level_1_1x.webp";
import TournamentsParticipation2x from "../assets/achievements/tournaments_participation_level_1/name_tournaments_participation_level_1_2x.webp";
import TournamentsParticipation3x from "../assets/achievements/tournaments_participation_level_1/name_tournaments_participation_level_1_3x.webp";
import TournamentsParticipation21x from "../assets/achievements/tournaments_participation_level_2/name_tournaments_participation_level_2_1x.webp";
import TournamentsParticipation22x from "../assets/achievements/tournaments_participation_level_2/name_tournaments_participation_level_2_2x.webp";
import TournamentsParticipation23x from "../assets/achievements/tournaments_participation_level_2/name_tournaments_participation_level_2_3x.webp";
import TournamentsParticipation31x from "../assets/achievements/tournaments_participation_level_3/name_tournaments_participation_level_3_1x.webp";
import TournamentsParticipation32x from "../assets/achievements/tournaments_participation_level_3/name_tournaments_participation_level_3_2x.webp";
import TournamentsParticipation33x from "../assets/achievements/tournaments_participation_level_3/name_tournaments_participation_level_3_3x.webp";

import BattleFriendsPlayedLock1x from "../assets/achievements/battle_friend_played/battle_friend_played_1x.webp";
import BattleFriendsPlayedLock2x from "../assets/achievements/battle_friend_played/battle_friend_played_2x.webp";
import BattleFriendsPlayedLock3x from "../assets/achievements/battle_friend_played/battle_friend_played_3x.webp";
import BattleFriendsPlayed1x from "../assets/achievements/battle_friends_played_level_1/name_battle_friends_played_level_1_1x.webp";
import BattleFriendsPlayed2x from "../assets/achievements/battle_friends_played_level_1/name_battle_friends_played_level_1_2x.webp";
import BattleFriendsPlayed3x from "../assets/achievements/battle_friends_played_level_1/name_battle_friends_played_level_1_3x.webp";
import BattleFriendsPlayed21x from "../assets/achievements/battle_friends_played_level_2/name_battle_friends_played_level_2_1x.webp";
import BattleFriendsPlayed22x from "../assets/achievements/battle_friends_played_level_2/name_battle_friends_played_level_2_2x.webp";
import BattleFriendsPlayed23x from "../assets/achievements/battle_friends_played_level_2/name_battle_friends_played_level_2_3x.webp";
import BattleFriendsPlayed31x from "../assets/achievements/battle_friends_played_level_3/name_battle_friends_played_level_3_1x.webp";
import BattleFriendsPlayed32x from "../assets/achievements/battle_friends_played_level_3/name_battle_friends_played_level_3_2x.webp";
import BattleFriendsPlayed33x from "../assets/achievements/battle_friends_played_level_3/name_battle_friends_played_level_3_3x.webp";

import WeeklyParticipationLock1x from "../assets/achievements/weekly_participation/weekly_participation_1x.webp";
import WeeklyParticipationLock2x from "../assets/achievements/weekly_participation/weekly_participation_2x.webp";
import WeeklyParticipationLock3x from "../assets/achievements/weekly_participation/weekly_participation_3x.webp";
import WeeklyParticipation1x from "../assets/achievements/weekly_participation_level_1/name_weekly_participation_level_1_1x.webp";
import WeeklyParticipation2x from "../assets/achievements/weekly_participation_level_1/name_weekly_participation_level_1_2x.webp";
import WeeklyParticipation3x from "../assets/achievements/weekly_participation_level_1/name_weekly_participation_level_1_3x.webp";
import WeeklyParticipation21x from "../assets/achievements/weekly_participation_level_2/name_weekly_participation_level_2_1x.webp";
import WeeklyParticipation22x from "../assets/achievements/weekly_participation_level_2/name_weekly_participation_level_2_2x.webp";
import WeeklyParticipation23x from "../assets/achievements/weekly_participation_level_2/name_weekly_participation_level_2_3x.webp";
import WeeklyParticipation31x from "../assets/achievements/weekly_participation_level_3/name_weekly_participation_level_3_1x.webp";
import WeeklyParticipation32x from "../assets/achievements/weekly_participation_level_3/name_weekly_participation_level_3_2x.webp";
import WeeklyParticipation33x from "../assets/achievements/weekly_participation_level_3/name_weekly_participation_level_3_3x.webp";

import WeeklyWinnerLock1x from "../assets/achievements/weekly_winner/weekly_winner_1x.webp";
import WeeklyWinnerLock2x from "../assets/achievements/weekly_winner/weekly_winner_2x.webp";
import WeeklyWinnerLock3x from "../assets/achievements/weekly_winner/weekly_winner_3x.webp";
import WeeklyWinner1x from "../assets/achievements/weekly_winner_level_1/name_weekly_winner_level_1_1x.webp";
import WeeklyWinner2x from "../assets/achievements/weekly_winner_level_1/name_weekly_winner_level_1_2x.webp";
import WeeklyWinner3x from "../assets/achievements/weekly_winner_level_1/name_weekly_winner_level_1_3x.webp";
import WeeklyWinner21x from "../assets/achievements/weekly_winner_level_2/name_weekly_winner_level_2_1x.webp";
import WeeklyWinner22x from "../assets/achievements/weekly_winner_level_2/name_weekly_winner_level_2_2x.webp";
import WeeklyWinner23x from "../assets/achievements/weekly_winner_level_2/name_weekly_winner_level_2_3x.webp";
import WeeklyWinner31x from "../assets/achievements/weekly_winner_level_3/name_weekly_winner_level_3_1x.webp";
import WeeklyWinner32x from "../assets/achievements/weekly_winner_level_3/name_weekly_winner_level_3_2x.webp";
import WeeklyWinner33x from "../assets/achievements/weekly_winner_level_3/name_weekly_winner_level_3_3x.webp";

import GrinderTier01x from "../assets/achievements/grinder_tier_0/grinder_tier_0@1x.webp";
import GrinderTier02x from "../assets/achievements/grinder_tier_0/grinder_tier_0@2x.webp";
import GrinderTier03x from "../assets/achievements/grinder_tier_0/grinder_tier_0@3x.webp";
import GrinderTier11x from "../assets/achievements/grinder_tier_1/grinder_tier_1@1x.webp";
import GrinderTier12x from "../assets/achievements/grinder_tier_1/grinder_tier_1@2x.webp";
import GrinderTier13x from "../assets/achievements/grinder_tier_1/grinder_tier_1@3x.webp";
import GrinderTier21x from "../assets/achievements/grinder_tier_2/grinder_tier_2@1x.webp";
import GrinderTier22x from "../assets/achievements/grinder_tier_2/grinder_tier_2@2x.webp";
import GrinderTier23x from "../assets/achievements/grinder_tier_2/grinder_tier_2@3x.webp";
import GrinderTier31x from "../assets/achievements/grinder_tier_3/grinder_tier_3@1x.webp";
import GrinderTier32x from "../assets/achievements/grinder_tier_3/grinder_tier_3@2x.webp";
import GrinderTier33x from "../assets/achievements/grinder_tier_3/grinder_tier_3@3x.webp";

import LibrarianTier01x from "../assets/achievements/librarian_tier_0/librarian_tier_0@1x.webp";
import LibrarianTier02x from "../assets/achievements/librarian_tier_0/librarian_tier_0@2x.webp";
import LibrarianTier03x from "../assets/achievements/librarian_tier_0/librarian_tier_0@3x.webp";
import LibrarianTier11x from "../assets/achievements/librarian_tier_1/librarian_tier_1@1x.webp";
import LibrarianTier12x from "../assets/achievements/librarian_tier_1/librarian_tier_1@2x.webp";
import LibrarianTier13x from "../assets/achievements/librarian_tier_1/librarian_tier_1@3x.webp";
import LibrarianTier21x from "../assets/achievements/librarian_tier_2/librarian_tier_2@1x.webp";
import LibrarianTier22x from "../assets/achievements/librarian_tier_2/librarian_tier_2@2x.webp";
import LibrarianTier23x from "../assets/achievements/librarian_tier_2/librarian_tier_2@3x.webp";
import LibrarianTier31x from "../assets/achievements/librarian_tier_3/librarian_tier_3@1x.webp";
import LibrarianTier32x from "../assets/achievements/librarian_tier_3/librarian_tier_3@2x.webp";
import LibrarianTier33x from "../assets/achievements/librarian_tier_3/librarian_tier_3@3x.webp";

import FilmBuffTier01x from "../assets/achievements/film_buff_tier_0/film_buff_tier_0@1x.webp";
import FilmBuffTier02x from "../assets/achievements/film_buff_tier_0/film_buff_tier_0@2x.webp";
import FilmBuffTier03x from "../assets/achievements/film_buff_tier_0/film_buff_tier_0@3x.webp";
import FilmBuffTier11x from "../assets/achievements/film_buff_tier_1/film_buff_tier_1@1x.webp";
import FilmBuffTier12x from "../assets/achievements/film_buff_tier_1/film_buff_tier_1@2x.webp";
import FilmBuffTier13x from "../assets/achievements/film_buff_tier_1/film_buff_tier_1@3x.webp";
import FilmBuffTier21x from "../assets/achievements/film_buff_tier_2/film_buff_tier_2@1x.webp";
import FilmBuffTier22x from "../assets/achievements/film_buff_tier_2/film_buff_tier_2@2x.webp";
import FilmBuffTier23x from "../assets/achievements/film_buff_tier_2/film_buff_tier_2@3x.webp";
import FilmBuffTier31x from "../assets/achievements/film_buff_tier_3/film_buff_tier_3@1x.webp";
import FilmBuffTier32x from "../assets/achievements/film_buff_tier_3/film_buff_tier_3@2x.webp";
import FilmBuffTier33x from "../assets/achievements/film_buff_tier_3/film_buff_tier_3@3x.webp";

import BrainstormBlitzTier01x from "../assets/achievements/brainstorm_blitz_tier_0/brainstorm_blitz_tier_0@1x.webp";
import BrainstormBlitzTier02x from "../assets/achievements/brainstorm_blitz_tier_0/brainstorm_blitz_tier_0@2x.webp";
import BrainstormBlitzTier03x from "../assets/achievements/brainstorm_blitz_tier_0/brainstorm_blitz_tier_0@3x.webp";
import BrainstormBlitzTier11x from "../assets/achievements/brainstorm_blitz_tier_1/brainstorm_blitz_tier_1@1x.webp";
import BrainstormBlitzTier12x from "../assets/achievements/brainstorm_blitz_tier_1/brainstorm_blitz_tier_1@2x.webp";
import BrainstormBlitzTier13x from "../assets/achievements/brainstorm_blitz_tier_1/brainstorm_blitz_tier_1@3x.webp";
import BrainstormBlitzTier21x from "../assets/achievements/brainstorm_blitz_tier_2/brainstorm_blitz_tier_2@1x.webp";
import BrainstormBlitzTier22x from "../assets/achievements/brainstorm_blitz_tier_2/brainstorm_blitz_tier_2@2x.webp";
import BrainstormBlitzTier23x from "../assets/achievements/brainstorm_blitz_tier_2/brainstorm_blitz_tier_2@3x.webp";
import BrainstormBlitzTier31x from "../assets/achievements/brainstorm_blitz_tier_3/brainstorm_blitz_tier_3@1x.webp";
import BrainstormBlitzTier32x from "../assets/achievements/brainstorm_blitz_tier_3/brainstorm_blitz_tier_3@2x.webp";
import BrainstormBlitzTier33x from "../assets/achievements/brainstorm_blitz_tier_3/brainstorm_blitz_tier_3@3x.webp";

import UnlockthepowerTier01x from "../assets/achievements/unlock_the_power_tier_0/unlock_the_power_tier_0@1x.webp";
import UnlockthepowerTier02x from "../assets/achievements/unlock_the_power_tier_0/unlock_the_power_tier_0@2x.webp";
import UnlockthepowerTier03x from "../assets/achievements/unlock_the_power_tier_0/unlock_the_power_tier_0@3x.webp";
import UnlockthepowerTier11x from "../assets/achievements/unlock_the_power_tier_1/unlock_the_power_tier_1@1x.webp";
import UnlockthepowerTier12x from "../assets/achievements/unlock_the_power_tier_1/unlock_the_power_tier_1@2x.webp";
import UnlockthepowerTier13x from "../assets/achievements/unlock_the_power_tier_1/unlock_the_power_tier_1@3x.webp";
import UnlockthepowerTier21x from "../assets/achievements/unlock_the_power_tier_2/unlock_the_power_tier_2@1x.webp";
import UnlockthepowerTier22x from "../assets/achievements/unlock_the_power_tier_2/unlock_the_power_tier_2@2x.webp";
import UnlockthepowerTier23x from "../assets/achievements/unlock_the_power_tier_2/unlock_the_power_tier_2@3x.webp";
import UnlockthepowerTier31x from "../assets/achievements/unlock_the_power_tier_3/unlock_the_power_tier_3@1x.webp";
import UnlockthepowerTier32x from "../assets/achievements/unlock_the_power_tier_3/unlock_the_power_tier_3@2x.webp";
import UnlockthepowerTier33x from "../assets/achievements/unlock_the_power_tier_3/unlock_the_power_tier_3@3x.webp";

import FacedOffTier01x from "../assets/achievements/faced_off_tier_0/faced_off_tier_0@1x.webp";
import FacedOffTier02x from "../assets/achievements/faced_off_tier_0/faced_off_tier_0@2x.webp";
import FacedOffTier03x from "../assets/achievements/faced_off_tier_0/faced_off_tier_0@3x.webp";
import FacedOffTier11x from "../assets/achievements/faced_off_tier_1/faced_off_tier_1@1x.webp";
import FacedOffTier12x from "../assets/achievements/faced_off_tier_1/faced_off_tier_1@2x.webp";
import FacedOffTier13x from "../assets/achievements/faced_off_tier_1/faced_off_tier_1@3x.webp";
import FacedOffTier21x from "../assets/achievements/faced_off_tier_2/faced_off_tier_2@1x.webp";
import FacedOffTier22x from "../assets/achievements/faced_off_tier_2/faced_off_tier_2@2x.webp";
import FacedOffTier23x from "../assets/achievements/faced_off_tier_2/faced_off_tier_2@3x.webp";
import FacedOffTier31x from "../assets/achievements/faced_off_tier_3/faced_off_tier_3@1x.webp";
import FacedOffTier32x from "../assets/achievements/faced_off_tier_3/faced_off_tier_3@2x.webp";
import FacedOffTier33x from "../assets/achievements/faced_off_tier_3/faced_off_tier_3@3x.webp";

import KnightsJourneyTier01x from "../assets/achievements/knights_journey_tier_0/knights_journey_tier_0@1x.webp";
import KnightsJourneyTier02x from "../assets/achievements/knights_journey_tier_0/knights_journey_tier_0@2x.webp";
import KnightsJourneyTier03x from "../assets/achievements/knights_journey_tier_0/knights_journey_tier_0@3x.webp";
import KnightsJourneyTier11x from "../assets/achievements/knights_journey_tier_1/knights_journey_tier_1@1x.webp";
import KnightsJourneyTier12x from "../assets/achievements/knights_journey_tier_1/knights_journey_tier_1@2x.webp";
import KnightsJourneyTier13x from "../assets/achievements/knights_journey_tier_1/knights_journey_tier_1@3x.webp";
import KnightsJourneyTier21x from "../assets/achievements/knights_journey_tier_2/knights_journey_tier_2@1x.webp";
import KnightsJourneyTier22x from "../assets/achievements/knights_journey_tier_2/knights_journey_tier_2@2x.webp";
import KnightsJourneyTier23x from "../assets/achievements/knights_journey_tier_2/knights_journey_tier_2@3x.webp";
import KnightsJourneyTier31x from "../assets/achievements/knights_journey_tier_3/knights_journey_tier_3@1x.webp";
import KnightsJourneyTier32x from "../assets/achievements/knights_journey_tier_3/knights_journey_tier_3@2x.webp";
import KnightsJourneyTier33x from "../assets/achievements/knights_journey_tier_3/knights_journey_tier_3@3x.webp";

import GamerTier01x from "../assets/achievements/gamer_tier_0/gamer_tier_0@1x.webp";
import GamerTier02x from "../assets/achievements/gamer_tier_0/gamer_tier_0@2x.webp";
import GamerTier03x from "../assets/achievements/gamer_tier_0/gamer_tier_0@3x.webp";
import GamerTier11x from "../assets/achievements/gamer_tier_1/gamer_tier_1@1x.webp";
import GamerTier12x from "../assets/achievements/gamer_tier_1/gamer_tier_1@2x.webp";
import GamerTier13x from "../assets/achievements/gamer_tier_1/gamer_tier_1@3x.webp";
import GamerTier21x from "../assets/achievements/gamer_tier_2/gamer_tier_2@1x.webp";
import GamerTier22x from "../assets/achievements/gamer_tier_2/gamer_tier_2@2x.webp";
import GamerTier23x from "../assets/achievements/gamer_tier_2/gamer_tier_2@3x.webp";
import GamerTier31x from "../assets/achievements/gamer_tier_3/gamer_tier_3@1x.webp";
import GamerTier32x from "../assets/achievements/gamer_tier_3/gamer_tier_3@2x.webp";
import GamerTier33x from "../assets/achievements/gamer_tier_3/gamer_tier_3@3x.webp";

import GameGrinderTier01x from "../assets/achievements/game_grinder_tier_0/game_grinder_tier_0@1x.webp";
import GameGrinderTier02x from "../assets/achievements/game_grinder_tier_0/game_grinder_tier_0@2x.webp";
import GameGrinderTier03x from "../assets/achievements/game_grinder_tier_0/game_grinder_tier_0@3x.webp";
import GameGrinderTier11x from "../assets/achievements/game_grinder_tier_1/game_grinder_tier_1@1x.webp";
import GameGrinderTier12x from "../assets/achievements/game_grinder_tier_1/game_grinder_tier_1@2x.webp";
import GameGrinderTier13x from "../assets/achievements/game_grinder_tier_1/game_grinder_tier_1@3x.webp";
import GameGrinderTier21x from "../assets/achievements/game_grinder_tier_2/game_grinder_tier_2@1x.webp";
import GameGrinderTier22x from "../assets/achievements/game_grinder_tier_2/game_grinder_tier_2@2x.webp";
import GameGrinderTier23x from "../assets/achievements/game_grinder_tier_2/game_grinder_tier_2@3x.webp";
import GameGrinderTier31x from "../assets/achievements/game_grinder_tier_3/game_grinder_tier_3@1x.webp";
import GameGrinderTier32x from "../assets/achievements/game_grinder_tier_3/game_grinder_tier_3@2x.webp";
import GameGrinderTier33x from "../assets/achievements/game_grinder_tier_3/game_grinder_tier_3@3x.webp";

import CasualCrusherTier01x from "../assets/achievements/casual_crusher_tier_0/casual_crusher_tier_0@1x.webp";
import CasualCrusherTier02x from "../assets/achievements/casual_crusher_tier_0/casual_crusher_tier_0@2x.webp";
import CasualCrusherTier03x from "../assets/achievements/casual_crusher_tier_0/casual_crusher_tier_0@3x.webp";
import CasualCrusherTier11x from "../assets/achievements/casual_crusher_tier_1/casual_crusher_tier_1@1x.webp";
import CasualCrusherTier12x from "../assets/achievements/casual_crusher_tier_1/casual_crusher_tier_1@2x.webp";
import CasualCrusherTier13x from "../assets/achievements/casual_crusher_tier_1/casual_crusher_tier_1@3x.webp";
import CasualCrusherTier21x from "../assets/achievements/casual_crusher_tier_2/casual_crusher_tier_2@1x.webp";
import CasualCrusherTier22x from "../assets/achievements/casual_crusher_tier_2/casual_crusher_tier_2@2x.webp";
import CasualCrusherTier23x from "../assets/achievements/casual_crusher_tier_2/casual_crusher_tier_2@3x.webp";
import CasualCrusherTier31x from "../assets/achievements/casual_crusher_tier_3/casual_crusher_tier_3@1x.webp";
import CasualCrusherTier32x from "../assets/achievements/casual_crusher_tier_3/casual_crusher_tier_3@2x.webp";
import CasualCrusherTier33x from "../assets/achievements/casual_crusher_tier_3/casual_crusher_tier_3@3x.webp";

import BattleMasterTier01x from "../assets/achievements/battle_master_tier_0/battle_master_tier_0@1x.webp";
import BattleMasterTier02x from "../assets/achievements/battle_master_tier_0/battle_master_tier_0@2x.webp";
import BattleMasterTier03x from "../assets/achievements/battle_master_tier_0/battle_master_tier_0@3x.webp";
import BattleMasterTier11x from "../assets/achievements/battle_master_tier_1/battle_master_tier_1@1x.webp";
import BattleMasterTier12x from "../assets/achievements/battle_master_tier_1/battle_master_tier_1@2x.webp";
import BattleMasterTier13x from "../assets/achievements/battle_master_tier_1/battle_master_tier_1@3x.webp";
import BattleMasterTier21x from "../assets/achievements/battle_master_tier_2/battle_master_tier_2@1x.webp";
import BattleMasterTier22x from "../assets/achievements/battle_master_tier_2/battle_master_tier_2@2x.webp";
import BattleMasterTier23x from "../assets/achievements/battle_master_tier_2/battle_master_tier_2@3x.webp";
import BattleMasterTier31x from "../assets/achievements/battle_master_tier_3/battle_master_tier_3@1x.webp";
import BattleMasterTier32x from "../assets/achievements/battle_master_tier_3/battle_master_tier_3@2x.webp";
import BattleMasterTier33x from "../assets/achievements/battle_master_tier_3/battle_master_tier_3@3x.webp";

export const ACHIEVEMENTS = [
  {
    icons: [
      {
        src1x: BattleWonLock1x,
        src2x: BattleWonLock2x,
        src3x: BattleWonLock3x,
      },
      {
        src1x: BattleWon1x,
        src2x: BattleWon2x,
        src3x: BattleWon3x,
      },
      {
        src1x: BattleWon21x,
        src2x: BattleWon22x,
        src3x: BattleWon23x,
      },
      {
        src1x: BattleWon31x,
        src2x: BattleWon32x,
        src3x: BattleWon33x,
      },
    ],
    name: "achievement_Conqueror",
    description: "achievement_Win battles",
    id: "battles_won",
    values: [
      { value: 10, gems: 20 },
      { value: 50, gems: 100 },
      { value: 100, gems: 200 },
    ],
  },
  {
    icons: [
      {
        src1x: BattleStreakLock1x,
        src2x: BattleStreakLock2x,
        src3x: BattleStreakLock3x,
      },
      {
        src1x: BattleStreak1x,
        src2x: BattleStreak2x,
        src3x: BattleStreak3x,
      },
      {
        src1x: BattleStreak21x,
        src2x: BattleStreak22x,
        src3x: BattleStreak23x,
      },
      {
        src1x: BattleStreak31x,
        src2x: BattleStreak32x,
        src3x: BattleStreak33x,
      },
    ],
    name: "achievement_Unstoppable",
    description: "achievement_Win battles in a row",
    id: "battle_streak",
    values: [
      { value: 5, gems: 25 },
      { value: 10, gems: 50 },
      { value: 20, gems: 100 },
    ],
  },
  {
    icons: [
      {
        src1x: ChallengerLock1x,
        src2x: ChallengerLock2x,
        src3x: ChallengerLock3x,
      },
      {
        src1x: Challenger1x,
        src2x: Challenger2x,
        src3x: Challenger3x,
      },
      {
        src1x: Challenger21x,
        src2x: Challenger22x,
        src3x: Challenger23x,
      },
      {
        src1x: Challenger31x,
        src2x: Challenger32x,
        src3x: Challenger33x,
      },
    ],
    name: "achievement_Challenger",
    description: "achievement_Complete unique challenges",
    id: "challenger",
    values: [
      { value: 10, gems: 10 },
      { value: 20, gems: 40 },
      { value: 50, gems: 250 },
    ],
  },
  {
    icons: [
      {
        src1x: CompletionistLock1x,
        src2x: CompletionistLock2x,
        src3x: CompletionistLock3x,
      },
      {
        src1x: Completionist1x,
        src2x: Completionist2x,
        src3x: Completionist3x,
      },
      {
        src1x: Completionist21x,
        src2x: Completionist22x,
        src3x: Completionist23x,
      },
      {
        src1x: Completionist31x,
        src2x: Completionist32x,
        src3x: Completionist33x,
      },
    ],
    name: "achievement_Mastery",
    description: "achievement_Complete all challenges of games",
    id: "completionist",
    values: [
      { value: 1, gems: 50 },
      { value: 5, gems: 250 },
      { value: 10, gems: 500 },
    ],
  },
  {
    icons: [
      {
        src1x: TournamentsParticipationLock1x,
        src2x: TournamentsParticipationLock2x,
        src3x: TournamentsParticipationLock3x,
      },
      {
        src1x: TournamentsParticipation1x,
        src2x: TournamentsParticipation2x,
        src3x: TournamentsParticipation3x,
      },
      {
        src1x: TournamentsParticipation21x,
        src2x: TournamentsParticipation22x,
        src3x: TournamentsParticipation23x,
      },
      {
        src1x: TournamentsParticipation31x,
        src2x: TournamentsParticipation32x,
        src3x: TournamentsParticipation33x,
      },
    ],
    name: "achievement_Gladiator",
    description: "achievement_Compete in tournaments",
    id: "tournaments_participation",
    values: [
      { value: 2, gems: 5 },
      { value: 10, gems: 30 },
      { value: 50, gems: 150 },
    ],
  },
  {
    icons: [
      {
        src1x: TimePlayedLock1x,
        src2x: TimePlayedLock2x,
        src3x: TimePlayedLock3x,
      },
      {
        src1x: TimePlayed1x,
        src2x: TimePlayed2x,
        src3x: TimePlayed3x,
      },
      {
        src1x: TimePlayed21x,
        src2x: TimePlayed22x,
        src3x: TimePlayed23x,
      },
      {
        src1x: TimePlayed31x,
        src2x: TimePlayed32x,
        src3x: TimePlayed33x,
      },
    ],
    name: "achievement_Devoted",
    description: "achievement_Play minutes of any game",
    id: "time_played",
    values: [
      { value: 100, gems: 50 },
      { value: 500, gems: 250 },
      { value: 1000, gems: 500 },
    ],
  },
  {
    icons: [
      {
        src1x: BattleFriendsPlayedLock1x,
        src2x: BattleFriendsPlayedLock2x,
        src3x: BattleFriendsPlayedLock3x,
      },
      {
        src1x: BattleFriendsPlayed1x,
        src2x: BattleFriendsPlayed2x,
        src3x: BattleFriendsPlayed3x,
      },
      {
        src1x: BattleFriendsPlayed21x,
        src2x: BattleFriendsPlayed22x,
        src3x: BattleFriendsPlayed23x,
      },
      {
        src1x: BattleFriendsPlayed31x,
        src2x: BattleFriendsPlayed32x,
        src3x: BattleFriendsPlayed33x,
      },
    ],
    name: "achievement_Showdown",
    description: "achievement_Play battles with friends",
    id: "battle_friends_played",
    values: [
      { value: 10, gems: 10 },
      { value: 50, gems: 50 },
      { value: 200, gems: 200 },
    ],
  },
  {
    icons: [
      {
        src1x: WeeklyParticipationLock1x,
        src2x: WeeklyParticipationLock2x,
        src3x: WeeklyParticipationLock3x,
      },
      {
        src1x: WeeklyParticipation1x,
        src2x: WeeklyParticipation2x,
        src3x: WeeklyParticipation3x,
      },
      {
        src1x: WeeklyParticipation21x,
        src2x: WeeklyParticipation22x,
        src3x: WeeklyParticipation23x,
      },
      {
        src1x: WeeklyParticipation31x,
        src2x: WeeklyParticipation32x,
        src3x: WeeklyParticipation33x,
      },
    ],
    name: "achievement_Contender",
    description: "achievement_Compete in weekly leaderboards",
    id: "weekly_gl_participant",
    values: [
      { value: 1, gems: 10 },
      { value: 7, gems: 70 },
      { value: 20, gems: 200 },
    ],
  },
  {
    icons: [
      {
        src1x: WeeklyWinnerLock1x,
        src2x: WeeklyWinnerLock2x,
        src3x: WeeklyWinnerLock3x,
      },
      {
        src1x: WeeklyWinner1x,
        src2x: WeeklyWinner2x,
        src3x: WeeklyWinner3x,
      },
      {
        src1x: WeeklyWinner21x,
        src2x: WeeklyWinner22x,
        src3x: WeeklyWinner23x,
      },
      {
        src1x: WeeklyWinner31x,
        src2x: WeeklyWinner32x,
        src3x: WeeklyWinner33x,
      },
    ],
    name: "achievement_Dominator",
    description: "achievement_Reach the top 10 in weekly leaderboards",
    id: "weekly_gl_winner",
    values: [
      { value: 1, gems: 30 },
      { value: 5, gems: 150 },
      { value: 10, gems: 300 },
    ],
  },

  {
    icons: [
      {
        src1x: FriendsInvitedLock1x,
        src2x: FriendsInvitedLock2x,
        src3x: FriendsInvitedLock3x,
      },
      {
        src1x: FriendsInvited1x,
        src2x: FriendsInvited2x,
        src3x: FriendsInvited3x,
      },
      {
        src1x: FriendsInvited21x,
        src2x: FriendsInvited22x,
        src3x: FriendsInvited23x,
      },
      {
        src1x: FriendsInvited31x,
        src2x: FriendsInvited32x,
        src3x: FriendsInvited33x,
      },
    ],
    name: "achievement_Influencer",
    description: "achievement_Have followers",
    id: "followers",
    values: [
      { value: 1, gems: 5 },
      { value: 10, gems: 50 },
      { value: 50, gems: 250 },
    ],
  },

  {
    icons: [
      {
        src1x: LibrarianTier01x,
        src2x: LibrarianTier02x,
        src3x: LibrarianTier03x,
      },
      {
        src1x: LibrarianTier11x,
        src2x: LibrarianTier12x,
        src3x: LibrarianTier13x,
      },
      {
        src1x: LibrarianTier21x,
        src2x: LibrarianTier22x,
        src3x: LibrarianTier23x,
      },
      {
        src1x: LibrarianTier31x,
        src2x: LibrarianTier32x,
        src3x: LibrarianTier33x,
      },
    ],
    name: "achievement_Librarian",
    description: "achievement_Read articles",
    id: "librarian",
    values: [
      { value: 5, gems: 10 },
      { value: 25, gems: 50 },
      { value: 100, gems: 200 },
    ],
  },
  {
    icons: [
      {
        src1x: FilmBuffTier01x,
        src2x: FilmBuffTier02x,
        src3x: FilmBuffTier03x,
      },
      {
        src1x: FilmBuffTier11x,
        src2x: FilmBuffTier12x,
        src3x: FilmBuffTier13x,
      },
      {
        src1x: FilmBuffTier21x,
        src2x: FilmBuffTier22x,
        src3x: FilmBuffTier23x,
      },
      {
        src1x: FilmBuffTier31x,
        src2x: FilmBuffTier32x,
        src3x: FilmBuffTier33x,
      },
    ],
    name: "achievement_FilmBuff",
    description: "achievement_Watch videos",
    id: "film_buff",
    values: [
      { value: 5, gems: 10 },
      { value: 25, gems: 50 },
      { value: 100, gems: 200 },
    ],
  },
  {
    icons: [
      {
        src1x: BrainstormBlitzTier01x,
        src2x: BrainstormBlitzTier02x,
        src3x: BrainstormBlitzTier03x,
      },
      {
        src1x: BrainstormBlitzTier11x,
        src2x: BrainstormBlitzTier12x,
        src3x: BrainstormBlitzTier13x,
      },
      {
        src1x: BrainstormBlitzTier21x,
        src2x: BrainstormBlitzTier22x,
        src3x: BrainstormBlitzTier23x,
      },
      {
        src1x: BrainstormBlitzTier31x,
        src2x: BrainstormBlitzTier32x,
        src3x: BrainstormBlitzTier33x,
      },
    ],
    name: "achievement_BrainstormBlitz",
    description: "achievement_Play games on QuizInc",
    id: "brainstorm_blitz",
    values: [
      { value: 10, gems: 40 },
      { value: 25, gems: 100 },
      { value: 100, gems: 400 },
    ],
  },
  {
    icons: [
      {
        src1x: UnlockthepowerTier01x,
        src2x: UnlockthepowerTier02x,
        src3x: UnlockthepowerTier03x,
      },
      {
        src1x: UnlockthepowerTier11x,
        src2x: UnlockthepowerTier12x,
        src3x: UnlockthepowerTier13x,
      },
      {
        src1x: UnlockthepowerTier21x,
        src2x: UnlockthepowerTier22x,
        src3x: UnlockthepowerTier23x,
      },
      {
        src1x: UnlockthepowerTier31x,
        src2x: UnlockthepowerTier32x,
        src3x: UnlockthepowerTier33x,
      },
    ],
    name: "achievement_UnlockThePower",
    description: "achievement_Play games on Unlock3",
    id: "unlock_the_power",
    values: [
      { value: 10, gems: 40 },
      { value: 25, gems: 100 },
      { value: 100, gems: 400 },
    ],
  },
  {
    icons: [
      {
        src1x: FacedOffTier01x,
        src2x: FacedOffTier02x,
        src3x: FacedOffTier03x,
      },
      {
        src1x: FacedOffTier11x,
        src2x: FacedOffTier12x,
        src3x: FacedOffTier13x,
      },
      {
        src1x: FacedOffTier21x,
        src2x: FacedOffTier22x,
        src3x: FacedOffTier23x,
      },
      {
        src1x: FacedOffTier31x,
        src2x: FacedOffTier32x,
        src3x: FacedOffTier33x,
      },
    ],
    name: "achievement_FacedOff",
    description: "achievement_Play games on Head 2 Head",
    id: "faced_off",
    values: [
      { value: 10, gems: 40 },
      { value: 25, gems: 100 },
      { value: 100, gems: 400 },
    ],
  },
  {
    icons: [
      {
        src1x: KnightsJourneyTier01x,
        src2x: KnightsJourneyTier02x,
        src3x: KnightsJourneyTier03x,
      },
      {
        src1x: KnightsJourneyTier11x,
        src2x: KnightsJourneyTier12x,
        src3x: KnightsJourneyTier13x,
      },
      {
        src1x: KnightsJourneyTier21x,
        src2x: KnightsJourneyTier22x,
        src3x: KnightsJourneyTier23x,
      },
      {
        src1x: KnightsJourneyTier31x,
        src2x: KnightsJourneyTier32x,
        src3x: KnightsJourneyTier33x,
      },
    ],
    name: "achievement_KnightJourney",
    description: "achievement_Play games on Chess Masters",
    id: "knight_journey",
    values: [
      { value: 10, gems: 40 },
      { value: 25, gems: 100 },
      { value: 100, gems: 400 },
    ],
  },
  {
    icons: [
      {
        src1x: GameGrinderTier01x,
        src2x: GameGrinderTier02x,
        src3x: GameGrinderTier03x,
      },
      {
        src1x: GameGrinderTier11x,
        src2x: GameGrinderTier12x,
        src3x: GameGrinderTier13x,
      },
      {
        src1x: GameGrinderTier21x,
        src2x: GameGrinderTier22x,
        src3x: GameGrinderTier23x,
      },
      {
        src1x: GameGrinderTier31x,
        src2x: GameGrinderTier32x,
        src3x: GameGrinderTier33x,
      },
    ],
    name: "achievement_GameGrinder",
    description: "achievement_Play games on Playinc",
    id: "game_grinder",
    values: [
      { value: 10, gems: 40 },
      { value: 25, gems: 100 },
      { value: 100, gems: 400 },
    ],
  },
    {
    icons: [
      {
        src1x: GamerTier01x,
        src2x: GamerTier02x,
        src3x: GamerTier03x,
      },
      {
        src1x: GamerTier11x,
        src2x: GamerTier12x,
        src3x: GamerTier13x,
      },
      {
        src1x: GamerTier21x,
        src2x: GamerTier22x,
        src3x: GamerTier23x,
      },
      {
        src1x: GamerTier31x,
        src2x: GamerTier32x,
        src3x: GamerTier33x,
      },
    ],
    name: "achievement_Gamer",
    description: "achievement_Play games",
    id: "gamer",
    values: [
      { value: 10, gems: 20 },
      { value: 25, gems: 40 },
      { value: 50, gems: 80 },
    ],
  },
  {
    icons: [
      {
        src1x: GrinderTier01x,
        src2x: GrinderTier02x,
        src3x: GrinderTier03x,
      },
      {
        src1x: GrinderTier11x,
        src2x: GrinderTier12x,
        src3x: GrinderTier13x,
      },
      {
        src1x: GrinderTier21x,
        src2x: GrinderTier22x,
        src3x: GrinderTier23x,
      },
      {
        src1x: GrinderTier31x,
        src2x: GrinderTier32x,
        src3x: GrinderTier33x,
      },
    ],
    name: "achievement_Grinder",
    description: "achievement_Login to AppName",
    id: "grinder",
    values: [
      { value: 10, gems: 20 },
      { value: 35, gems: 70 },
      { value: 100, gems: 200 },
    ],
  },
  {
    icons: [
      {
        src1x: CasualCrusherTier01x,
        src2x: CasualCrusherTier02x,
        src3x: CasualCrusherTier03x,
      },
      {
        src1x: CasualCrusherTier11x,
        src2x: CasualCrusherTier12x,
        src3x: CasualCrusherTier13x,
      },
      {
        src1x: CasualCrusherTier21x,
        src2x: CasualCrusherTier22x,
        src3x: CasualCrusherTier23x,
      },
      {
        src1x: CasualCrusherTier31x,
        src2x: CasualCrusherTier32x,
        src3x: CasualCrusherTier33x,
      },
    ],
    name: "achievement_CasualCrusher",
    description: "achievement_Play games on CA",
    id: "casual_crusher",
    values: [
      { value: 10, gems: 40 },
      { value: 25, gems: 100 },
      { value: 100, gems: 400 },
    ],
  },
  {
    icons: [
      {
        src1x: BattleMasterTier01x,
        src2x: BattleMasterTier02x,
        src3x: BattleMasterTier03x,
      },
      {
        src1x: BattleMasterTier11x,
        src2x: BattleMasterTier12x,
        src3x: BattleMasterTier13x,
      },
      {
        src1x: BattleMasterTier21x,
        src2x: BattleMasterTier22x,
        src3x: BattleMasterTier23x,
      },
      {
        src1x: BattleMasterTier31x,
        src2x: BattleMasterTier32x,
        src3x: BattleMasterTier33x,
      },
    ],
    name: "achievement_BattleMaster",
    description: "achievement_Play games on ONMO",
    id: "battle_master",
    values: [
      { value: 10, gems: 40 },
      { value: 25, gems: 100 },
      { value: 50, gems: 400 },
    ],
  },
];

export const ACHIEVEMENTS_BG_COLORS = [
  "linear-gradient(270deg, #4F4F4F 0%, #DADADA 100%)",
  "linear-gradient(270deg, #154260 0%, #2B6891 62.17%, #88C6F5 100%)",
  "linear-gradient(269.96deg, #C6882D 0.03%, #FFF8ED 97.98%)",
  "linear-gradient(316.94deg, #181818 37.86%, #B5B5B5 90.44%)",
];

export const ACHIEVEMENTS_ORDER = [
  "battles_won",
  "battle_streak",
  "challenger",
  "completionist",
  "tournaments_participation",
  "battle_friends_played",
  "weekly_gl_participant",
  "weekly_gl_winner",
  "grinder",
  "gamer",
  "librarian",
  "film_buff",
  "casual_crusher",
  "battle_master",
  "brainstorm_blitz",
  "unlock_the_power",
  "faced_off",
  "knight_journey",
  "game_grinder",
  "time_played",
  "followers",
];

export const PRODUCT_QUERY = [
  "ca",
  "onmo",
  "chessmasters",
  "playinc",
  "quizhead2head",
  "quizinc",
  "stopclock",
  "tgp",
  "unlock3",
];
